import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/api/client';
import type { PurchaseDesk, SupplierDesk } from '@core/api/purchaseDesk';
import { purchaseDeskPath, supplierDeskPath } from '@core/api/queryPaths';

export type {
  PurchaseDesk,
  SupplierDesk,
  SupplierDeskRow,
  SupplierEvent,
} from '@core/api/purchaseDesk';

/**
 * The purchase desk reads what orders, deliveries, bills and payments say, so every write to any of
 * them invalidates it — callers add this key beside their own.
 */
export const purchaseDeskKey = ['purchase-desk'] as const;

export function usePurchaseDesk(branchId: number | undefined, all: boolean) {
  return useQuery({
    queryKey: [...purchaseDeskKey, branchId, all],
    queryFn: () => apiFetch<PurchaseDesk>(purchaseDeskPath(all)),
    enabled: branchId !== undefined,
    placeholderData: (previous) => previous,
  });
}

export function useSupplierDesk(vendorId: number | null) {
  return useQuery({
    queryKey: [...purchaseDeskKey, 'supplier', vendorId],
    queryFn: () => apiFetch<SupplierDesk>(supplierDeskPath(vendorId ?? 0)),
    enabled: vendorId !== null,
  });
}
